import limeBrainsLogo from '../../images/lime-brains-logo.svg'

import headerLogo from '../../images/header_bg.jpg'

import mazarLogo from '../../images/Mazars_logo.svg.png'
import nokiaLogo from '../../images/Nokia_wordmark.svg.png'
import siemensLogo from '../../images/Siemens-logo.svg.png'

export const MazarLogo = mazarLogo
export const NokiaLogo = nokiaLogo
export const SiemensLogo = siemensLogo

export const LimeBrainsLogo = limeBrainsLogo

export const HeaderLogo = headerLogo
